import App from './App.svelte';
import './assets/styles/bootstrap/bootstrap.scss';

var app = new App({
	target: document.body
});

export default app;